<template>

  <section style="width: 800px; margin: 0 auto; display: flex; flex-flow: row; min-height: 500px; align-items: flex-start">
    <div class="tooltip" style="margin-right: 200px; width: 400px;">

      <div style="margin-bottom: 30px; border-bottom: 1px solid #ddd; padding-bottom: 10px; ">Buttons</div>

      <a class="tooltip__button-branded button-branded button-branded--is-white"><span class="button-branded__label">PARKAVE</span></a>
      <div style="height: 30px;"></div>
      <a class="tooltip__button-branded button-branded button-branded--is-blue"><span class="button-branded__label">PARKAVE</span></a>
      <div style="height: 30px;"></div>
      <a href="#" class="button-dfp button-dfp--is-green"></a>
      <div style="height: 30px;"></div>
      <a href="#" class="button-dfp button-dfp--is-white"></a>
    </div>

    <div class="tooltip" style="width: 400px;">

      <div style="margin-bottom: 30px; border-bottom: 1px solid #ddd; padding-bottom: 10px;">Click "Parkave"... and then click "Browse all"...</div>

      <a @click="showTooltipCreative = !showTooltipCreative" class="tooltip__button-branded button-branded button-branded--is-blue"><span class="button-branded__label">PARKAVE</span></a>

      <aside class="tooltip__wrapper" v-bind:class="{'tooltip__wrapper--is-visible': showTooltipCreative}">

        <header class="tooltip__header">
          <h1 class="tooltip__header__title">Insert my creative</h1>
        </header>

        <div class="tooltip__input input input--search input--search-outline">
          <input type="text" placeholder="Search my creatives" class="input__field">
        </div>

        <ul class="tooltip__list">
          <li class="tooltip__list__item" v-for="index in 4" :key="index" >
            <a href="#" class="tooltip__list__link">
              <figure class="tooltip__list__image">
                <img class="tooltip__list__image__source" src="https://via.placeholder.com/40x40/2558BB/ffffff" alt="">
              </figure>

              <span class="tooltip__list__title">Rook Coffee</span>
            </a>
          </li>
        </ul>
        <footer class="tooltip__footer">
          <a @click="(showTooltipSize = !showTooltipSize); (showTooltipCreative = false)" class="tooltip__footer__link link link--chevron">Browse all</a>
        </footer>
      </aside>

      <aside class="tooltip__wrapper" v-bind:class="{'tooltip__wrapper--is-visible': showTooltipSize}">

        <header class="tooltip__header tooltip__header--has-prefix">
          <a @click="(showTooltipSize = false); (showTooltipCreative = true)" href="#" class="tooltip__header__prefix"><span class="tooltip__header__prefix__label">Back</span></a>

          <h1 class="tooltip__header__title">Choose size</h1>
        </header>

        <ul class="tooltip__list">
          <li class="tooltip__list__item" v-for="index in 4" :key="index" >
            <a href="#" class="tooltip__list__link">
              <span class="tooltip__list__title">728x320</span>
            </a>
          </li>
        </ul>
      </aside>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'InsertCreative',
  components: {},
  mounted(){},
  computed: {},
  methods: {},
  data () {
    return {
      'showTooltipCreative': false,
      'showTooltipSize': false,
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/InsertCreative.vue